/**
 * Created by glesouchu on 16.07.2014.
 */
export class StringUtils {
    /**
     * Encrypt the string.
     *
     * This function exist only for readability
     *
     * @param str Value to be encrypted.
     * @return The string encrypted.
     */
    public static encrypt(str: string): string {
        return StringUtils.invertString(str);
    }

    /**
     * Decrypt the string.
     *
     * This function exist only for readability
     *
     * @param str Value to be decrypted.
     * @return The string decrypted.
     */
    public static decrypt(str: string): string {
        return StringUtils.invertString(str);
    }

    /**
     * Method used to invert the characters binary charCode of the <code>String</code>.
     * @param str Value to be converted.
     * @return <code>String</code> converted.
     */
    public static invertString(str: string): string {
        let result: any[] = [];

        for (let i: number = 0; i < str.length; i++) {
            result.push(String.fromCharCode(str.charCodeAt(i) ^ 0xff));
        }

        return result.join('');
    }
}
